import { useState, useEffect } from "react";
import { useGetRequest } from "../../Client/index.js";
import { useParams, useNavigate } from "react-router-dom";
import HeaderPreRegistration from "../../Components/HeaderPreRegistration";
import UserRow from "./UserRow.js";
import { usePreReg } from "../PreRegContext";

function PreRegistration() {
  const [users, setUsers] = useState([]);

  const navigate = useNavigate();

  const { bookingReference } = useParams();

  const { contextPreReg, setContextPreReg } = usePreReg();

  useEffect(() => {
    setContextPreReg(bookingReference);
  }, [bookingReference, setContextPreReg]);

  const { status, data } = useGetRequest(
    `registration/booking/users/${bookingReference}`,
    {}
  );

  const { status: DMNstatus, data: DMNdata } = useGetRequest(
    `dmn/${bookingReference}`,
    {}
  );

  useEffect(() => {
    if (DMNstatus === "fetched") {
      if (DMNdata?.date === "") {
        navigate("/pre-registration", {
          state: { error: `Invalid booking reference ${bookingReference}` },
        });
      }
      if (DMNdata?.redirect) {
        navigate(`/pre-registration/${DMNdata.redirect}`);
      }
    }
  }, [DMNdata]);

  useEffect(() => {
    if (status === "fetched") {
      setUsers(data.users || []);
    }
  }, [status, data]);

  return (
    <div className="min-h-screen flex flex-col bg-[#070d27] text-white">
      <HeaderPreRegistration
        bookingReference={bookingReference}
        hideHome={true}
      />

      <div className="flex flex-1">
        <main className="flex-1 p-2 sm:p-6 flex justify-center items-start">
          {DMNstatus === "fetching" && (
            <div className="absolute inset-0 z-50 bg-[#070d27]/80 backdrop-blur-sm flex items-center justify-center">
              <div className="flex flex-col items-center gap-4">
                <div className="w-10 h-10 border-4 border-white/30 border-t-white rounded-full animate-spin" />
                <span className="Kallisto_Bold text-white/90">
                  Checking booking…
                </span>
              </div>
            </div>
          )}

          <div className="flex flex-col gap-2 items-center text-center w-full px-4">
            {users.length === 0 && (
              <div className="Kallisto_Bold text-3xl">No users registered</div>
            )}

            {users.length === 1 && (
              <div className="Kallisto_Bold text-3xl">1 user registered</div>
            )}

            {users.length > 1 && (
              <div className="Kallisto_Bold text-3xl">
                {users.length} users registered
              </div>
            )}

            {users?.map((user, index) => (
              <UserRow
                key={user.ballerzUserID}
                item={user}
                bookingReference={bookingReference}
                onDelete={(ballerzUserID) =>
                  setUsers((prev) =>
                    prev.filter((u) => u.ballerzUserID !== ballerzUserID)
                  )
                }
              />
            ))}

            <div className="flex justify-center w-full mt-10 gap-4">
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded flex items-center w-4/5 sm:w-1/5"
                onClick={() =>
                  navigate("/pre-registration/email", {
                    state: {
                      bookingReference: bookingReference,
                    },
                  })
                }
              >
                <span className="Kallisto_Bold text-center w-full">
                  Add Player
                </span>
              </button>

              {users?.length > 0 && (
                <button
                  className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded flex items-center w-4/5 sm:w-1/5"
                  onClick={() => {
                    navigate("/pre-registration/finished", {
                      state: {
                        bookingReference,
                      },
                    });
                  }}
                >
                  <span className="Kallisto_Bold text-center w-full">
                    Finished
                  </span>
                </button>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default PreRegistration;
